// this file gets replaced with the real value during the build
export default '6.9.0' as string;
